import React, { Component } from 'react';

import Loading from 'Demora/Loading';

import socialHttp from '../../../../utils/socialHttp';

import { Link, withRouter } from 'react-router-dom';

class GroupJoin extends Component {
	constructor(props) {
		super();

		let joinCode = props.joinCode;

		if (!joinCode) {
			joinCode = props.match.params.code;
		}

		this.state = {
			data: null,
			joinCode: joinCode,
		};
	}

	componentDidMount() {
		this.getData();
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	getData() {
		socialHttp('get', '/data/groups/' + this.state.joinCode + '/join')
			.then((data) => {
				if (!this.unmounted) {
					if (data.groupUser) {
						this.props.history.push('/profile/' + data.group);
						return;
					}

					this.setState({
						data: data,
					});
				}
			})
			.catch((e) => {
				throw e;
			});
	}

	join() {
		socialHttp('post', '/data/groups/' + this.state.joinCode + '/join')
			.then((data) => {
				if (!this.unmounted) {
					this.getData();
				}
			})
			.catch((e) => {
				throw e;
			});
	}

	render() {
		let state = this.state;

		if (state.data === null) {
			return <Loading />;
		}

		let content = null;

		let groupData = state.data;

		if (!groupData.group) {
			content = (
				<div>
					This group doesn't exist, please check the link you've been given.
				</div>
			);
		} else {
			let content1 = null;

			if (groupData.groupJoin) {
				content1 = (
					<div>
						Your request to join has been sent and the owner of the group will
						contact you shortly.
					</div>
				);
			} else {
				content1 = (
					<div className='row text-center'>
						<div className='col-12 mt-5 mb-5'>
							{groupData.groupPrivate
								? 'This is a private group that you\'ve been invited to. If you would like to send a request to join, click on the "Join" button below.'
								: "If you'd like to join this group, click on the Join button below to send a request to the group owner."}
						</div>

						<div className='col-6'>
							<Link className='btn btn-danger' to='/home'>
								Cancel
							</Link>
						</div>

						<div className='col-6'>
							<button
								className='btn btn-primary'
								onClick={this.join.bind(this)}
							>
								Join
							</button>
						</div>
					</div>
				);
			}

			content = (
				<div>
					<h3>{groupData.groupName}</h3>

					<div style={{ maxWidth: '400px' }}>{content1}</div>
				</div>
			);
		}

		return (
			<div className='d-flex align-items-center justify-content-center text-center'>
				{content}
			</div>
		);
	}
}

export default withRouter(GroupJoin);
